import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../../store/state";
import { Pane, PaneContainer, PaneTitle } from "../../Panes.style";
import { Referrals } from "../../../shared/Referrals/Referrals";
import { QuickPayCardPaymentMethod, QuickPayMobilePayPaymentMethod, WidgetPane3ReferralsProps } from "../../../../types/WidgetProps";
import { usePlausible } from "next-plausible";
import { EffektButton } from "../../../../../EffektButton/EffektButton";
export const QuickPayPane: React.FC<{
  config: QuickPayCardPaymentMethod | QuickPayMobilePayPaymentMethod;
  referrals: WidgetPane3ReferralsProps;
}> = t0 => {
  const $ = _c(13);
  const {
    config,
    referrals
  } = t0;
  const donation = useSelector(_temp);
  const {
    paymentProviderURL,
    recurring
  } = donation;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PaneTitle>QuickPay</PaneTitle>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== paymentProviderURL) {
    t2 = () => {
      if (paymentProviderURL) {
        window.location.href = paymentProviderURL;
      }
    };
    $[1] = paymentProviderURL;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = recurring ? config.recurring_button_text : config.single_button_text;
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <EffektButton onClick={t2}>{t3}</EffektButton>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== referrals.other_referral_input_placeholder || $[7] !== referrals.referrals_title || $[8] !== referrals.show_referrals) {
    t5 = !(referrals.show_referrals === false) && <Referrals text={{
      referrals_title: referrals.referrals_title,
      other_referral_input_placeholder: referrals.other_referral_input_placeholder
    }} />;
    $[6] = referrals.other_referral_input_placeholder;
    $[7] = referrals.referrals_title;
    $[8] = referrals.show_referrals;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <Pane><PaneContainer>{t1}{t4}{t5}</PaneContainer></Pane>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp(state) {
  return state.donation;
}